module.exports = __webpack_public_path__ + "static/media/Footer.07e10172.scss";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/components/shs/Footer/Footer.scss
// module id = 3783
// module chunks = 0